import type { Player } from "../types/game";

export function calcNetWorth(player: Player): number {
  const investmentValue = player.investments.reduce((sum, inv) => sum + inv.currentValue, 0);
  const itemValue = player.ownedItems.reduce((sum, item) => sum + item.resaleValue, 0);
  return player.cash + investmentValue + itemValue;
}

export function rankPlayers(players: Player[]): Player[] {
  return [...players].sort((a, b) => calcNetWorth(b) - calcNetWorth(a));
}

export function calcCostOfLiving(round: number, base: number): number {
  const inflationSteps = Math.floor((round - 1) / 2);
  return base + inflationSteps * 5;
}
